import { Fragment } from "react";
import dynamic from "next/dynamic";
import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";
import { hasProperty } from "../../utils/validate";

const RecallsPage = dynamic(() => import("../../components/Shared/Pages/Recalls"));

const endpoint = "cars/recalls";

const RecallCars = props => {
	const { token } = props;
	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(["cars", "recalls"], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error')) {
		return <Error error={data.error} errorCode={data.error.code} />
	}

	return (
		<Fragment>
			<RecallsPage
				pageData={data}
				category={"Cars"}
			/>
		</Fragment>
	);
};

RecallCars.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["cars", "recalls"], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default RecallCars;